import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * BrandRow
 * Right-aligned logo row. Keeps layout simple and responsive.
 */
export default function BrandRow({ logoSrc, alt = 'Logo', backTo = null }) {
  const navigate = useNavigate();
  if (backTo) {
    return (
      <div className="w-full flex items-center justify-between gap-2 mb-4">
        <button
          type="button"
          className="p-2 rounded-md text-primary hover:bg-primary/5"
          onClick={() => navigate(backTo)}
          aria-label="Back to Patient Overview"
        >
          <svg viewBox="0 0 24 24" className="w-6 h-6" aria-hidden="true">
              <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <img src={logoSrc} alt={alt} className="h-8 md:h-16 lg:h-20 w-auto opacity-90" />
      </div>
    );
  }
  return (
    <div className="w-full flex items-start justify-end gap-2 mb-4">
      <img src={logoSrc} alt={alt} className="h-8 md:h-16 lg:h-20 w-auto opacity-90" />
    </div>
  );
}


